import { JSXElementConstructor, ReactElement } from "react";

import { Button, IconButton } from "@/storybook-components/";

function ActionButton({
  type,
  icon,
  label,
  onClick
}: {
  type: "button" | "icon";
  icon: ReactElement<any, string | JSXElementConstructor<any>>;
  label: string;
  onClick?: () => void;
}) {
  if (type === "button") {
    return (
      <Button
        fontSize="md"
        aria-label={label}
        leftIcon={icon}
        onClick={onClick}
        variant="primary"
        fontWeight="semibold"
        size={{ base: "lg", xl: "md" }}
      >
        {label}
      </Button>
    );
  }

  return (
    <IconButton
      aria-label={label}
      icon={icon}
      onClick={onClick}
      zIndex={2}
      rounded="full"
      boxShadow="lg"
      color="gray.900"
      background="white"
      _hover={{ background: "white" }}
      _focus={{ background: "white" }}
      w={{ base: 10, sm: 12, xl: 10 }}
      h={{ base: 10, sm: 12, xl: 10 }}
    />
  );
}

export default ActionButton;
